export default __webpack_public_path__ + "static/media/ibcLogoNew.96483af4.svg";